var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5e708d",
    stroke: "#707070",
    d: "M-385.266 35.5h18v18h-18z",
    "data-name": "Rectangle 12035"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 338",
    transform: "translate(385.266 -35.5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-385.266 35.5h18v18h-18z",
    "data-name": "Rectangle 12036"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#5e708d",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-376.266 37.75a6.75 6.75 0 1 1-6.75 6.75 6.75 6.75 0 0 1 6.75-6.75m0-1.5a8.213 8.213 0 1 0 5.845 2.405 8.25 8.25 0 0 0-5.845-2.405Z",
    "data-name": "Path 15946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-372.516 47.5a.638.638 0 0 1-.375-.112l-4.125-2.475V40.75a.75.75 0 0 1 1.5 0v3.337l3.375 2.025a.747.747 0 0 1-.375 1.388Z",
    "data-name": "Path 15947"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.628e8d6fba5a259655f5cbb7d8a4208c.svg";
export { ForwardRef as ReactComponent };